module.exports = __webpack_public_path__ + "img/cross__icon.219b6d77.svg";